import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["box", "form", "input"];

  connect() {
    this.dismissed = false; // closed by user (click 'close' button)
    this.footerVisible = false;
    this.triggered = false; // track if box has been triggered once

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll);

    // Footer observer (if 'footer' class is on viewport, hide newsletter box)
    const footer = document.querySelector(".footer");
    if (footer) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.footerVisible = true;
              this.hide();
            } else {
              this.footerVisible = false;
              if (this.triggered && !this.dismissed) this.show();
            }
          });
        },
        { threshold: 0.1 }
      );

      this.footerObserver.observe(footer);
    }

    // Check on page load
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.footerObserver) {
      this.footerObserver.disconnect();
    }
  }

  onScroll() {
    if (this.dismissed || this.triggered) return;

    const scrollPosition = window.scrollY; // top of viewport
    const viewportHeight = window.innerHeight;
    const triggerPoint = viewportHeight * 0.5;

    if (scrollPosition >= triggerPoint) {
      this.show();
      this.triggered = true; // only trigger once
    }
  }

  show() {
    this.boxTarget.classList.add("newsletter-box--visible");
  }

  hide() {
    this.boxTarget.classList.remove("newsletter-box--visible");
  }

  close() {
    this.hide();
    this.dismissed = true; // permanently hide until refresh
  }

  clearInput(event) {
    if (event.detail.success) {
      // Turbo only sends success on 2xx
      if (this.hasInputTarget) {
        this.inputTarget.value = "";
      }
      this.close();
    }
  }
}
